<mat-card>
  <mat-card-header>
    <mat-card-title>
      <mat-icon>cloud</mat-icon>&nbsp;{{'batch_diff_selector_dialog_title' | transloco}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if ({sites: batchs$ | async, dateFormat: dateFormat$ | async}; as items) {
      <div class="content">
        <div>{{'batch_diff_selector_dialog_message' | transloco}}</div>
        @if (!(advancedFeaturesAvailable$ | async)) {
          <div style="padding-top: 10px">
            {{'advanced_features_required' | transloco}}
          </div>
        }
        <!--      <div >-->
        <!--        <mat-form-field>-->
        <!--          <mat-label>{{'batch_compared' | transloco}}</mat-label>-->
        <!--          <mat-select [formControl]="batchReferenceControl">-->
        <!--            @for (batch of items.batchs; track batch) {-->
        <!--            <mat-option [value]="batch.id" [disabled]="batch.id == batchReferenceControl.value">{{batch.dateAcquired | date:items.dateFormat}}</mat-option>-->
        <!--            }-->
      <!--          </mat-select>-->
    <!--        </mat-form-field>-->
  <!--      </div>-->
  <!--      <div >-->
  <!--        <mat-form-field>-->
  <!--          <mat-label>{{'batch_reference' | transloco}}</mat-label>-->
  <!--          <mat-select [formControl]="batchComparedControl">-->
  <!--            @for (batch of items.batchs; track batch) {-->
  <!--            <mat-option [value]="batch.id" [disabled]="batch.id == batchComparedControl.value">{{batch.dateAcquired | date:items.dateFormat}}</mat-option>-->
  <!--            }-->
<!--          </mat-select>-->
<!--        </mat-form-field>-->
<!--      </div>-->
</div>
}

</mat-card-content>
<mat-card-actions>
  <button mat-button (click)="dialogRef.close()">{{'cancel' | transloco}}</button>
  <button mat-button
    cdkFocusInitial
    color="primary"
    [disabled]="!batchComparedControl.value || !batchReferenceControl.value || !(advancedFeaturesAvailable$ | async)"
            (click)="dialogRef.close(
            {'first': batchComparedControl.value, 'second': batchReferenceControl.value
            })">{{'validate' | transloco}}</button>
</mat-card-actions>
</mat-card>
